// src/components/Footer.js

import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; 

// Import your logo and social media icons
import logoImage from '../assets/logo.png';
import facebookIcon from '../assets/about-page/icon-facebook.png';
import twitterIcon from '../assets/about-page/icon-twitter.png';
import instagramIcon from '../assets/about-page/icon-instagram.png';
import linkedinIcon from '../assets/about-page/icon-linkedin.png';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-left">
          <img src={logoImage} alt="Govindam Logo" className="footer-logo" />
          <nav className="footer-nav">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
          </nav>
        </div>
        <div className="footer-right">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
            <img src={facebookIcon} alt="Facebook"/>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
            <img src={twitterIcon} alt="Twitter"/>
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
            <img src={instagramIcon} alt="Instagram"/>
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
            <img src={linkedinIcon} alt="LinkedIn"/>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;